import styled from '@emotion/styled';
import { Card } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import AspectRatioFixed from '../../../component/primitive/AspectRatioFixed';
import DummyContent from '../../../component/primitive/DummyContent';
import DummyRectangle from '../../../component/primitive/DummyRectangle';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';

export type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const CreationsDummyItem = ({ className }: Props) => (
  <Root className={className}>
    <Avatar />

    <AssigneeName size="body1" length={50} />

    <DeliverableCreatedAt size="body1" length={90} />

    <Video aspectRatio={[1, 1]}>
      <DummyRectangle />
    </Video>
  </Root>
);

const Root = styled(Card)({
  ...gridLayoutContainer({
    columns: ['16px', '40px', '16px', '1fr', '16px'],
    rows: ['24px', '24px', '16px', 'auto'],
    areas: [
      ['.', 'avatar', '.', 'assigneeName', '.'],
      ['.', 'avatar', '.', 'deliverableCreatedAt', '.'],
      ['.', '.', '.', '.', '.'],
      ['video', 'video', 'video', 'video', 'video'],
    ],
  }),
  paddingTop: 16,
});

const Avatar = styled(DummyRectangle)({
  ...gridLayoutItem('avatar', {
    alignSelf: 'center',
  }),
  width: 40,
  height: 40,
  borderRadius: '50%',
});

const AssigneeName = styled(DummyContent)(gridLayoutItem('assigneeName'));

const DeliverableCreatedAt = styled(DummyContent)(gridLayoutItem('deliverableCreatedAt'));

const Video = styled(AspectRatioFixed)({
  ...gridLayoutItem('video'),
});

export default CreationsDummyItem;
